
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Detail from "../../../components/events/detail";
import PublicDetail from "../../../components/events/public_detail";
import { useRouter } from "next/router";
import { useQuery, QueryClient, dehydrate } from "@tanstack/react-query";
import { getEventDetail, handleError } from "../../../src/queries";
import { useEffect } from "react";
import Head from "next/head";
import { useSession } from "next-auth/react";
import { shorten } from "../../../helpers/application";
import { authOptions } from "../../../pages/api/auth/[...nextauth]";
import { unstable_getServerSession } from "next-auth/next";
import { eventDateTime } from "../../../helpers/event_helper";
import { bearerHeader } from "../../../src/queries";
const Index = () => {
    const router = useRouter();
    const slug = router.query.slug;
    const { data, refetch } = useQuery(["events", slug], () => getEventDetail(slug), {
        onError: (error) => handleError(error, router)
    });
    useEffect(() => {
        if (data && slug === data.token) {
            router.replace(router.asPath.replace(data.token, data.slug));
        }
    }, [data]);
    const { data: session } = useSession();
    const baseURL = `${process.env.NEXT_PUBLIC_APP_URL}/images/socials`;
    const metaDescription = () => {
        if (data) {
            return `${shorten(`${data.name} ${eventDateTime(data)} - ${data.street}, ${data.city}. ${data.description ? data.description : ""}`, 160)}`;
        }
    };
    const eventTitle = () => {
        if (data) {
            return `${data.name} ${eventDateTime(data)} | unalanu`;
        }
    };
    return (data && (<>
        <Head>
          <title>{eventTitle()}</title>
          <meta name="description" content={metaDescription()}/>
          <link href={`${process.env.NEXT_PUBLIC_APP_URL}/events/${data.slug}`} rel="canonical"/>
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:site" content="@unalanu"/>
          <meta name="twitter:title" content={eventTitle()}/>
          <meta name="twitter:description" content={metaDescription()}/>
          <meta name="twitter:image" content={`${baseURL}/twitter.png`}/>
          <meta name="twitter:image:alt" content="unalanu social logo"/>

          <meta name="og:title" content={eventTitle()}/>
          <meta name="og:description" content={metaDescription()}/>
          <meta name="og:url" content={`${process.env.NEXT_PUBLIC_APP_URL}/events/${data.slug}`}/>
          <meta name="og:image" content={`${baseURL}/facebook.png`}/>
        </Head>

        {session?.user ? (<Detail refetch={refetch} event={data} backLink={router.query.backLink}/>) : (<PublicDetail event={data} backLink={router.query.backLink}/>)}
      </>));
};
export default Index;
async function getServerSideProps(context) {
    const queryClient = new QueryClient();
    const session = await unstable_getServerSession(context.req, context.res, authOptions);
    const slug = context.params.slug;
    try {
        const endpoint = session?.user
            ? getEventDetail(slug, { Authorization: bearerHeader(session) })
            : getEventDetail(slug);
        await queryClient.fetchQuery(["events", slug], () => endpoint);
    }
    catch (error) {
        if (!session && error?.response?.status == 401) {
            return {
                redirect: {
                    destination: `${process.env.NEXT_PUBLIC_APP_URL}/sign_in?error=SessionRequired`,
                    permanent: false
                }
            };
        }
    }
    return {
        props: { dehydratedState: dehydrate(queryClient) }
    };
}

    async function __Next_Translate__getServerSideProps__195eb204a99__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/events/[slug]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__195eb204a99__ as getServerSideProps }
  